import type { TurnBlock } from './types.js';
import { durationSecs } from './parsers.js';

/**
 * Mark any in-flight (`in_progress`/`pending`) tool_call blocks as `cancelled`,
 * stamping their duration. Used when the user interrupts a turn: the agent
 * stops mid-tool and — for Codex and Claude — never sends a terminal tool
 * update, so the row would otherwise spin on "Running…" forever.
 *
 * `cancelled` is treated as a sticky terminal status by the protocol handlers
 * (acp-handler `tool_call_update`, claude-handler tool_result) so a late
 * `completed`/`failed` update from the agent (e.g. OpenCode's post-abort
 * `tool_call_update`) cannot revert a tool the user explicitly cancelled.
 */
export function cancelInFlightTools(blocks: TurnBlock[], eventTimestamp: number): TurnBlock[] {
  return blocks.map((b) =>
    b.type === 'tool_call' && (b.status === 'in_progress' || b.status === 'pending')
      ? { ...b, status: 'cancelled' as const, duration: durationSecs(b.startedAt, eventTimestamp) }
      : b,
  );
}
